module.exports = __webpack_public_path__ + "assets/images/home/footer-bg.95c5b3a7d221914065dfb37b3619057c.webp";